import { cellErrors } from "@/react/components/table/useTableMutations";
import {
  destinationTypeSelector,
  generateStoreRowId,
  setDestinationTypes,
} from "@/react/features/support-tools/extensions/forwarding-rules/destionationTypeSlice";
import { useSelector } from "react-redux";
import useEditableCell from "@/react/components/table/useEditableCell";
import * as yup from "yup";
import schema from "@/react/features/support-tools/extensions/forwarding-rules/schema";
import { useCallback, useEffect } from "react";
import { store } from "@/react/store/store";

export const useDestinationCell = (props, rule) => {
  const errors = cellErrors(props);
  const storeRowId = generateStoreRowId(props.row?.id, rule);
  const destinationType = useSelector(destinationTypeSelector(storeRowId));
  const { value } = useEditableCell(props);

  if (!props.row) {
    return { errors, destinationType: "", value };
  }

  const destinationTypeCell = props.row
    ?.getAllCells()
    .find(
      (c) =>
        c.column.id ===
        yup.reach(schema, `forwardingRules.${rule}.destination.destinationType`)
          .spec.key
    )
    ?.getContext();

  const updateDestinationTypes = useCallback((newValue) => {
    store.dispatch(
      setDestinationTypes({
        rowId: storeRowId,
        destinationType: newValue,
      })
    );
  }, []);

  const { value: destinationTypeValue } = useEditableCell({
    ...destinationTypeCell,
    externalOnChange: updateDestinationTypes,
  });

  useEffect(() => {
    updateDestinationTypes(destinationTypeValue);
  }, [destinationTypeValue]);

  return { errors, destinationType, value };
};
